import defaultAttributes from '../defaultAttributes';

const Music2 = [
  'svg',
  defaultAttributes,
  [['circle', { cx: '8', cy: '18', r: '4' }], ['path', { d: 'M12 18V2l7 4' }]],
];

export default Music2;
